import { PortfolioEditNameComponent } from './portfolio-edit-name/portfolio-edit-name.component';
import { PortfolioViewHistoryComponent } from './portfolio-view-history/portfolio-view-history.component';
import { PortfolioLookupResolveService } from './shared/portfolio-lookup-resolve.service';
import { PortfolioViewComponent } from './portfolio-view/portfolio-view.component';
import { PortfolioAddComponent } from './portfolio-add/portfolio-add.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PortfolioListComponent } from './portfolio-list/portfolio-list.component';
import { PortfolioShellComponent } from './portfolio-shell/portfolio-shell.component';
import { RouteApplicationStartupResolveService } from '../core/route-application-startup-resolve.service';
import { AuthGuard } from '../core/auth.guard';

const portfoliosRoutes: Routes = [
  {
    path: 'portfolios',
    component: PortfolioShellComponent,
    canActivate: [AuthGuard],
    resolve: {
      appData: RouteApplicationStartupResolveService,
      lookupData: PortfolioLookupResolveService,
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'list',
      },
      {
        path: 'list',
        component: PortfolioListComponent,
      },
      {
        path: 'save',
        component: PortfolioAddComponent,
      },
      {
        path: 'account-managers/list',
        component: PortfolioAddComponent,
      },
      {
        path: 'view/:id',
        component: PortfolioViewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(portfoliosRoutes)],
  exports: [RouterModule],
})
export class PortfoliosRoutingModule {}
